import type * as React from 'react';
import ReactMarkdown from 'react-markdown';
import { useFragment } from 'react-relay';
import { markdownBlockFragment } from './MarkdownBlock.relay';
import type { MarkdownBlockPropsType } from './types';

export const markdownBlockClassName = 'my-[35px] leading-[21px] first:mt-0 self-stretch';

export const markdownComponents = {
  h2: ({ children, ...props }: React.HTMLAttributes<HTMLHeadingElement>) => (
    <h2 className="text-black text-2xl leading-[26px] mb-4" {...props}>
      {children}
    </h2>
  ),
  h3: ({ children, ...props }: React.HTMLAttributes<HTMLHeadingElement>) => (
    <h3 className="text-sm font-sans font-bold leading-[21px]" {...props}>
      {children}
    </h3>
  ),
  ul: ({ children, ...props }: React.HTMLAttributes<HTMLUListElement>) => (
    <ul className="list-none my-[22px]" {...props}>
      {children}
    </ul>
  ),
  li: ({ children, ...props }: React.HTMLAttributes<HTMLLIElement>) => (
    <li className="bg-[url(/static/front/assets/other-icons/bullet-point.png)] bg-no-repeat bg-position-[0_9px] pl-[34px] mb-[5px] [&>ul]:m-0" {...props}>
      {children}
    </li>
  ),
};

const MarkdownBlock: React.FC<MarkdownBlockPropsType> = (props: MarkdownBlockPropsType) => {
  const contentBlock = useFragment(markdownBlockFragment, props.contentBlock);

  return (
    <div className={markdownBlockClassName}>
      <ReactMarkdown components={markdownComponents}>{contentBlock.markdown}</ReactMarkdown>
    </div>
  );
};

export { MarkdownBlock };
